/**
 * Created by Suhel Shrestha on 1/15/20
 */
import moment from 'moment';
import {getDisplayDate} from "./date";

const time = (value) => {
  if(Date.parse(value) !== 'NaN' && !!Date.parse(value)) return getDisplayDate(value, {format: 'HH:mm:ss'});

  let second = value % 60,
      minuteHour = (value - second) / 60,
      minute = minuteHour % 60,
      hour = (minuteHour - minute) / 60;
  return getDisplayDate(moment().hours(hour).minutes(minute).seconds(second).format('YYYY-MM-DDTHH:mm:ss'), {format: 'HH:mm:ss'});
};

const parameterTypeParser = (value, type) => {
  if(!type) return value;
  switch(type.toLowerCase()){
    case 'time': return time(value);
    case 'text': return value;
    // default: return typeof value === 'string' ? value : Math.round(value * 100) / 100;
    default: return typeof value === 'string' ? value : value;
  }
};

export default parameterTypeParser;


// WEBPACK FOOTER //
// ./src/libs/parameterTypeParser.js